import { Button } from "@dash/form";
import { HeaderBar } from "@dash/page";
import { MdCancel, MdLocalShipping, MdOpenInNew } from "react-icons/md";

import { Order } from "@megaron/fulfillment-contracts";

import { getShopifyOrderUrl } from "./constants";
import { shouldShowShopifyCancelButton } from "./orderPackingUtils";

type Props = {
  orderData: Order;
  onOpenCancelShopify: () => void;
  shouldShowCourierButton: boolean;
  isCourierAlreadyScheduled: boolean;
  onScheduleCourier: () => void;
};

export const OrderPackingHeaderBar = ({
  orderData,
  onOpenCancelShopify,
  shouldShowCourierButton,
  isCourierAlreadyScheduled,
  onScheduleCourier,
}: Props) => (
  <HeaderBar
    header={`WEB-${orderData.orderNumber}`}
    actions={
      <>
        {shouldShowShopifyCancelButton(orderData) && (
          <Button
            variant="outline"
            color="inverse"
            size="small"
            icon={<MdCancel />}
            onClick={onOpenCancelShopify}
          >
            Zwrot / anuluj
          </Button>
        )}
        {shouldShowCourierButton && (
          <Button
            variant="outline"
            color="inverse"
            size="small"
            icon={<MdLocalShipping />}
            isDisabled={isCourierAlreadyScheduled}
            onClick={onScheduleCourier}
          >
            Zamów kuriera
          </Button>
        )}
        <a
          href={getShopifyOrderUrl(orderData.id)}
          target="_blank"
          rel="noopener noreferrer"
          css={{
            display: "inline-flex",
            textDecoration: "none",
            color: "inherit",
          }}
        >
          <Button variant="outline" color="inverse" size="small" icon={<MdOpenInNew />} as="div">
            Shopify
          </Button>
        </a>
      </>
    }
  />
);
